export const AppEnvs = {
  siteKey: process.env.REACT_APP_SITE_KEY || '',
  apiURL: process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL || '',
  sentryDSN: process.env.REACT_APP_SENTRY_DSN || '',
  environment: process.env.REACT_APP_ENV || 'dev',
  appCategoryLimit: Number(process.env.REACT_APP_MAX_APP_CATEGORIES) || 10,
  rewardsTypeLimit: Number(process.env.REACT_APP_MAX_REWARDS_TYPES) || 5,
  equalTrafficConfig: safeParseJson<Record<string, number>>(
    process.env.REACT_APP_EQUAL_TRAFFIC_CONFIG,
    {}
  ),
  integrationAPIURL: process.env.REACT_APP_TRAFFIC_EXCHANGE_INTEGRATION_API_URL || ''
};

// helper function
function safeParseJson<T>(json: string | undefined, fallback: T): T {
  try {
    return json ? JSON.parse(json) : fallback;
  } catch {
    return fallback;
  }
}
